import React from "react";
import {
  Card,
  CardBody,
  Row,
  Col,
  FormGroup,
  Input,
  CustomInput,
} from "reactstrap";
import { useTranslation } from "react-i18next";
import smartAlarm from "assets/img/smartAlarm.png";
import { connect } from "react-redux";
const AlarmEdit = (props) => {
  const { t } = useTranslation(["devices", "common"]);
  const updateParts = () => {
    return props.alarmConfirmEdit(
      props.id,
      props.edit.name,
      props.edit.text,
      props.edit.everyone
    );
  };
  console.log("rawAlarms", props.rawAlarms);
  return (
    <>
      <Col xl="4" lg="6" md="6" xs="12">
        <Card>
          <CardBody className="alerts_body">
            <div className="alerts_btns">
              <i
                className="alerts_icons tim-icons icon-check-2"
                onClick={updateParts}
              />
            </div>
            <Row className="h-100">
              <Col xs="9">
                {props.rawAlarms ? (
                  <div className="rawAlarms">
                    You cannot edit alarm settings with raw alarms settings
                    enabled.
                  </div>
                ) : (
                  <>
                    <div className="name">{t("common:name")}</div>
                    <div className="title">
                      <FormGroup>
                        <Input
                          placeholder={t("common:name")}
                          value={props.edit.name || ""}
                          onChange={(e) =>
                            props.alarmPreEdit(props.id, "name", e.target.value)
                          }
                          type="text"
                        />
                      </FormGroup>
                    </div>
                    <Row className="alerts_desc_edit">
                      <div className="name">{t("common:text")}</div>
                      <div className="title">
                        <FormGroup>
                          <Input
                            placeholder={t("common:text")}
                            value={props.edit.text || ""}
                            onChange={(e) =>
                              props.alarmPreEdit(
                                props.id,
                                "text",
                                e.target.value
                              )
                            }
                            type="text"
                          />
                        </FormGroup>
                      </div>
                    </Row>
                    <Row className="alerts_everyone">
                      <Col xs="8" className="alerts_everyone_title">
                        <div className="title">Mention @everyone</div>
                      </Col>
                      <Col xs="4" className="alerts_everyone_switch">
                        <CustomInput
                          type="switch"
                          id={`alerts-${props.id}`}
                          className="alerts_checkbox"
                          checked={props.edit.everyone}
                          onChange={(e) =>
                            props.alarmPreEdit(
                              props.id,
                              "everyone",
                              e.target.checked
                            )
                          }
                        />
                      </Col>
                    </Row>
                  </>
                )}
              </Col>
              <Col xs="3" className="m-auto">
                <img className="alerts_img" alt="icon" src={smartAlarm} />
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Col>
    </>
  );
};

const mapStateToProps = (state) => {
  const { rawAlarms } = state.settings;
  return { rawAlarms };
};

//export default AlarmEdit;
export default connect(mapStateToProps, false)(AlarmEdit);
